import React, { useEffect, useState } from "react";
import moment from "moment";
import "./GroupSubSkillCard.scss";
import { SubSkillCardInterface } from "../../../interfaces";
import { Card, CardContent } from "@material-ui/core";
import LinearProgress from '@material-ui/core/LinearProgress';
import translate from "../../../i18n/translate";
import withStyles from "@material-ui/core/styles/withStyles";
import { useSelector } from "react-redux";

const LinearProgressThick = withStyles((theme) => ({
  root: {
    height: 7,
    borderRadius: 10,
  },
}))(LinearProgress);

const GroupSubSkillCard = (props: SubSkillCardInterface) => {
  const allInfo = useSelector((state: any) => state);
  const [badge, setBadge] = useState("");

  useEffect(()=> {
    if(!!allInfo.skillOutcomeSummary.data && allInfo.skillOutcomeSummary.data.length > 0) {
      let matchedSkillNamesList = allInfo.skillOutcomeSummary.data.filter((summary : any) => {
        return summary.skill_name === props.subSkillData.skilltitle
      });
      if(matchedSkillNamesList.length > 0 ) {
        let isBadgeAvailable = matchedSkillNamesList.filter((summary : any) => summary.skill_name === props.subSkillData.skilltitle)
        if(isBadgeAvailable[0].skill_summary[0].badge !== "No Badge") {
          setBadge(allInfo.skillOutcomeSummary.data.filter((summary : any) => summary.skill_name===props.subSkillData.skilltitle)[0].skill_summary[0].badge);
        }
      }
    }
  },[allInfo.skillOutcomeSummary, props]);

  const getIncompleteStatus = (skillData: any) => {     
    switch(skillData.sessionstatus) {
      case 0:
        return translate("progress_subskill_sessionStatusUpcoming");
      case 1:
        return translate("progress_subskill_sessionStatusScheduled");
      case 2:
        return translate("progress_subskill_sessionStatusCompleted");
      case 3:
        return translate("progress_subskill_sessionStatusAbsent");
      case 4:
        return translate("progress_subskill_sessionStatusScheduling");
      default: 
        return translate("progress_subskill_sessionStatusNotCompleted");
    }           
  }
  
  return (
    <React.Fragment>
      {props.subSkillData.subskilltitle &&
        <Card className="subskill-card group-subskill-card">
          <CardContent className="subskill-card-body">
            <div className="subskill-list-title">{props.subSkillData.subskilltitle}   
            </div>
            <div className="subskill-list-body">
              { 
                <div className="subskill-progress-block">
                  <div className="subskill-progress-block-1">
                    <div className="subskill-progress-label">{translate("progress_subskill_preworkTitle")}</div>
                    <div className={"subskill-progress-bar"}>
                      <LinearProgressThick variant="determinate" value={props.subSkillData.totalprework !== 0 ? (props.subSkillData.preworkcompleted / props.subSkillData.totalprework) * 100 : 0} />
                    </div>
                    <div className={"subskill-progress-status"}>
                      { props.subSkillData.totalprework !== 0 ? Math.round((props.subSkillData.preworkcompleted / props.subSkillData.totalprework) * 100) : 0 }%
                    </div>
                  </div>
                  {
                    props.showHomeWork && (
                      <div className="subskill-progress-block-1">
                      <div className="subskill-progress-label">{translate("progress_subskill_homeworkTitle")}</div>
                      <div className="subskill-progress-bar">
                        <LinearProgressThick variant="determinate" value={props.subSkillData.totalhomework !== 0 ? (props.subSkillData.homeworkcompleted / props.subSkillData.totalhomework) * 100 : 0} />
                      </div>
                      <div className={"subskill-progress-status"}>
                      { props.subSkillData.totalhomework !== 0 ? Math.round((props.subSkillData.homeworkcompleted / props.subSkillData.totalhomework)) * 100 : 0 }%
                      </div>
                    </div>
                    )
                  }
                  {
                    <div className="subskill-progress-block-1 subskill-progress-session-block">
                      <span className="subskill-progress-label">{translate("progress_subskill_sessionTitle")}</span>
                      <div className="subskill-progress-bar">
                      { props.subSkillData.hasSession ? 
                          <span className={`sess-text${props.subSkillData.sessionstatus === 2 ? "-completed" : ""}`}>{getIncompleteStatus(props.subSkillData)}</span> : 
                          <span className="sess-text">{translate("progress_subskill_sessionStatusNoSessions")}</span>
                        }
                        {/* <LinearProgressThick variant="determinate" value={props.subSkillData.totalhomework !== 0 ? (props.subSkillData.sessions / props.subSkillData.totalsessions) * 100 : 0} /> */}
                      </div>
                      <div className="subskill-progress-status">
                        {/* <span className="sess-text">{translate("progress_subskill_sessionTitle")}</span> */}
                        { props.subSkillData.sessioncompleteddate ? 
                          <span className="sess-text">{moment.unix(props.subSkillData.sessioncompleteddate).format("DD MMM YYYY / hh:mm A")}</span> : 
                          <span  className="sess-text">{translate("progress_subskill_sessionNoDate")}</span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </CardContent>
        </Card>
      }
    </React.Fragment>
  )
};

export default GroupSubSkillCard;
